import React, { forwardRef } from 'react';

/**
 * The popper body used with react-popper-tooltip. Pass the `getTooltipProps` /
 * `getArrowProps` getters and the ref that usePopperTooltip() hands back.
 */
const TileTooltip = forwardRef(function TileTooltip({ tooltipText, getTooltipProps, getArrowProps }, ref) {
    return (
        <div
            ref={ref}
            data-popper-reference-hidden="true"
            {...getTooltipProps({
                className: 'tw-flex tw-flex-col tw-gap-y-2 tw-bg-blue tw-p-2.5 tw-rounded-lg tw-border-0 tw-text-xs tw-text-white',
                style: { maxWidth: '20rem' },
            })}
        >
            {tooltipText}
        </div>
    );
});

export default TileTooltip;
export { TileTooltip };
